<template>
  <div class="bg-white p-4">
    <div class="flex justify-between items-center my-3">
      <div>
        <h2 class="text-2xl font-semibold">List of Wishes</h2>
      </div>
      <base-button
        outline
        type="primary"
        class="flex px-3 py-1 mx-1"
        @click="handleOpen"
      >
        <feather-icon icon="PlusIcon" class="mr-1"></feather-icon>Add
      </base-button>
    </div>
    <div>
      <el-table
        border
        :data="tableData"
        style="width: 100%"
        class="mt-4 rounded"
        header-row-class-name="thead-light table-th-color "
        @selection-change="selectedRow"
      >
        <el-table-column type="selection" width="50px"> </el-table-column>

        <!-- <el-table-column prop="name" label="Title" v-slot="{ row }">
          test
        </el-table-column> -->
        <el-table-column prop="name" label="Title" v-slot="{ row }">
          {{ row.title }}
        </el-table-column>
        <el-table-column prop="type" label="Description" v-slot="{ row }">
          {{ row.description }}
        </el-table-column>
        <el-table-column prop="type" label="Price" v-slot="{ row }">
          {{ row.price }}
        </el-table-column>
        <!-- <el-table-column prop="type" label="Views" v-slot="{ row }">
          {{ row.numOfViews }}
        </el-table-column> -->
        <el-table-column
          label="Created On"
          prop="editedby"
          min-width="80px"
          v-slot="{ row }"
        >
          {{ new Date(row.createdAt).toDateString() }}
        </el-table-column>
        <el-table-column
          label="Actions"
          min-width="80px"
          class-name="text-center"
        >
          <template slot-scope="scope">
            <div class="flex justify-center items-center">
              <div class="flex">
                <feather-icon
                  icon="Edit2Icon"
                  svgClasses="w-4 text-blue-600 cursor-pointer"
                  class="ml-2"
                  @click="handleEdit(scope.row)"
                ></feather-icon>
              </div>

              <div class="flex" @click="handleDelete(scope.row._id)">
                <feather-icon
                  icon="Trash2Icon"
                  svgClasses="w-5 text-red-600 cursor-pointer"
                  class="ml-2"
                ></feather-icon>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <b-card-footer class="py-4 d-flex justify-content-end">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          @change="handlePageChange"
        ></b-pagination>
      </b-card-footer>
    </div>
    <b-modal
      modal-content-classes="cust-modal-ht"
      header-bg-variant="primary"
      header-text-variant="white"
      id="add-donor"
      :title="`${action} Wish`"
      hide-footer
    >
      <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
        <b-form
          role="form"
          @submit.prevent="
            action == 'Edit'
              ? handleSubmit(handleEditFunc)
              : handleSubmit(handleCreate)
          "
        >
          <div class="mb-4">
            <p class="input-title text-black">Title</p>
            <base-input
              v-model="title"
              placeholder="Type..."
              class="md:border-0 lg:border-0 custipshadow"
              name="Name"
              :rules="{ required: true }"
            ></base-input>
          </div>
          <div class="mb-4">
            <p class="input-title text-black">Description</p>
            <base-input
              class=""
              :rules="{ required: true, min: 10, max: 200 }"
              v-model="description"
              name="Description"
            >
              <textarea
                v-model="description"
                class="form-control"
                placeholder="Type..."
                id="exampleFormControlTextarea3"
                rows="5"
              ></textarea>
            </base-input>
          </div>
          <div class="mb-4">
            <p class="input-title text-black">Price</p>
            <base-input
              class=""
              :rules="{ required: true, numeric }"
              v-model="price"
              name="Price"
            >
            </base-input>
          </div>
          <!-- <div class="mb-4">
            <p class="input-title text-black">Number of Views</p>
            <base-input
              class=""
              :rules="{ numeric }"
              v-model="numOfViews"
              name="Views"
            >
            </base-input>
          </div> -->
          <div class="flex justify-center">
            <b-button
              v-if="action == 'Edit'"
              class="font-semibold"
              type="primary"
              native-type="submit"
              variant="primary"
              >Update</b-button
            >
            <b-button
              v-else
              class="font-semibold"
              type="primary"
              native-type="submit"
              variant="primary"
              >Save</b-button
            >
          </div>
        </b-form>
      </validation-observer>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import _ from "lodash";

export default {
  components: {},
  data() {
    return {
      tableData: [],
      title: "Number of users fulfilled the wish",
      price: 0,
      numOfViews: 0,
      editItem: {},
      description: "",
      action: "Add",
    };
  },
  methods: {
    async handleCreate() {
      let payload = {
        title: this.title,
        description: this.description,
        price: this.price,
        numOfViews: this.numOfViews,
      };
      await this.$store.dispatch("services/addWishes", payload);
      this.reset();
      this.handleGet();
    },
    async handleGet() {
      let payload = { pagination: false };
      let result = await this.$store.dispatch("services/getWishes", payload);
      console.log(result, "RESULT");
      this.tableData = result.data.data;
    },
    reset() {
      this.$bvModal.hide("add-donor");
      this.title = "";
      this.description = "";
    },
    handleOpen() {
      this.action = "Add";
      this.title = "";
      this.description = "";
      (this.price = 0), (this.numOfViews = 0), this.$bvModal.show("add-donor");
    },
    async handleEdit(data) {
      this.action = "Edit";
      this.editItem = data;
      this.title = data.title;
      this.description = data.description;
      this.price = data.price;
      this.numOfViews = data.numOfViews;
      this.$bvModal.show("add-donor");
    },
    async handleEditFunc() {
      let payload = {
        _id: this.editItem._id,
      };
      if (this.title != this.editItem.title) {
        Object.assign(payload, { title: this.title });
      }
      if (this.description != this.editItem.description) {
        Object.assign(payload, { description: this.description });
      }
      if (this.price != this.editItem.price) {
        Object.assign(payload, { price: this.price });
      }
      if (this.numOfViews != this.editItem.numOfViews) {
        Object.assign(payload, { numOfViews: this.numOfViews });
      }
      let result = await this.$store.dispatch("services/editWishes", payload);
      this.reset();
      this.handleGet();
    },
    async handleDelete(ID) {
      this.$swal
        .fire({
          text: "Are you sure you want to delete?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#830c81",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            let result = await this.$store.dispatch("services/deleteWishes", {
              _id: ID,
              isDeleted: true,
            });
            this.reset();
            this.handleGet();
            this.$swal.fire({
              text: "Deleted Successfully",
              icon: "success",
              confirmButtonText: "Okay",
              confirmButtonColor: "#830c81",
              showCancelButton: false,
            });
          }
        });
    },
  },
  async mounted() {
    await this.handleGet();
  },
};
</script>

<style>
.modal-header {
  display: flex !important;
  align-items: center !important;
  background-color: #4f0a4b !important;
  border-color: #4f0a4b !important;
  padding: 10px !important;
}

.modal-title {
  font-size: 20px !important;
  color: #fff !important;
}
.form-group {
  margin-bottom: 0.5rem;
}
input.is-invalid ~ .custom-file-label {
  border-color: #cad1d7;
}
.widtht30percent {
  width: 30%;
  height: 140px !important;
}
</style>
